<template>
  <div class="d-flex align-center justify-center flex-column full--height">
    <v-alert
      text
      outlined
      :color="alertState === 'success' ? 'success' : 'error'"
      dismissible
      v-model="alertDisplay"
      icon="info"
      max-width="350px"
    >
      {{ alertMessage }}
    </v-alert>
    <v-card outlined max-width="350px">
      <div class="d-flex justify-space-between align-center px-4 py-2">
        <h3 v-text="$t('account.passwordResetTitle')"></h3>
      </div>
      <v-divider></v-divider>
      <v-progress-linear
        :active="isLoading"
        :indeterminate="isLoading"
        bottom
        color="secondary"
      ></v-progress-linear>
      <v-form
        ref="searchAccountForm"
        v-model="valid"
        lazy-validation
        class="pa-4"
        :key="resetKey"
      >
        <v-text-field
          outlined
          color="primary"
          name="email"
          v-bind:label="$t('account.email')"
          v-model="email"
          :rules="emailRules"
          required
        ></v-text-field>
        <v-btn
          color="primary"
          large
          block
          @click="searchAccount()"
          :disabled="!valid"
          v-text="$t('account.searchAccount')"
        >
        </v-btn>
      </v-form>
    </v-card>
  </div>
</template>

<script>
/* SERVICES */
import AccountService from "../../account/services/AccountService";

export default {
  data() {
    return {
      valid: true,
      isLoading: false,
      alertDisplay: false,
      alertState: "success",
      alertMessage: null,
      email: null,
      resetKey: 0,
      emailRules: [
        v => !!v || this.$i18n.t("account.rules.email.required"),
        v => /.+@.+\..+/.test(v) || this.$i18n.t("account.rules.email.valid")
      ]
    };
  },
  methods: {
    searchAccount() {
      if (this.$refs.searchAccountForm.validate()) {
        this.isLoading = true;
        AccountService.askForResetAccountPassword(this.email)
          .then(() => {
            this.alertMessage = this.$t(
              "account.successMessageAfterSearchAccount"
            );
            this.email = null;
          })
          .catch(() => {
            this.alertMessage = this.$t(
              "account.errorMessageAfterSearchAccount"
            );
          })
          .finally(() => {
            this.isLoading = false;
            this.alertDisplay = true;
            this.valid = true;
            this.resetKey++;
          });
      }
    }
  }
};
</script>
